import { isEmpty } from 'lodash';
import { Point3D } from '../../team-apis/otterdam/answers/shape-typings';
import {
  calibrationInputKey,
  cameraInitialRotationInputKey,
  locationsInputKey,
  maxInputKey,
  minInputKey,
  Task,
} from '../../team-apis/otterdam/task';

export enum Input {
  Min = minInputKey,
  Max = maxInputKey,
  CalibrationParameters = calibrationInputKey,
  InitialRotation = cameraInitialRotationInputKey,
  SensorLocations = locationsInputKey,
}

export function getInputData<InputDataType>(
  key: string,
  task: Task,
): InputDataType | undefined {
  const taskData = task.data[key];
  // Computed input value can be undefined or empty string
  return !isEmpty(taskData) ? JSON.parse(taskData) : undefined;
}

export function loadAssetBoundingBoxForOutput(outputName: string, task: Task) {
  const minKey = `${outputName} ${Input.Min}`;
  const maxKey = `${outputName} ${Input.Max}`;

  const min = getInputData<Point3D>(minKey, task);
  const max = getInputData<Point3D>(maxKey, task);

  return min && max ? { min, max } : undefined;
}
